/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axiosInstance from './axios';
import PaginationData from 'types/models/PaginationData';
import SitefConfig from 'types/models/SitefConfig';

export const getSitefConfigs = async (page?: number): Promise<PaginationData<SitefConfig> | null> => {
  try {
    const { data: paginationData } = await axiosInstance({
      method: 'get',
      url: `payments/sitef/configs?page=${page ?? 1}`,
    });
    return {
      currentPage: paginationData.current_page,
      data: parseSitefConfigs(paginationData.data),
      perPage: paginationData.per_page,
      total: paginationData.total,
    };
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getSitefConfig = async (id: string): Promise<SitefConfig | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: `payments/sitef/configs/${id}`,
    });
    return parseConfig(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const storeSitefConfig = async (sitefConfig: SitefConfig): Promise<SitefConfig | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'post',
      url: 'payments/sitef/config',
      data: {
        description: sitefConfig.description,
        merchant_id: sitefConfig.merchantId,
        merchant_key: sitefConfig.merchantKey,
      },
    });
    return parseConfig(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateSitefConfig = async (sitefConfig: SitefConfig): Promise<SitefConfig | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'post',
      url: `payments/sitef/config?_method=put`,
      data: {
        id: sitefConfig.id,
        description: sitefConfig.description,
        merchant_id: sitefConfig.merchantId,
        merchant_key: sitefConfig.merchantKey,
      },
    });
    return parseConfig(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteSitefConfig = async (id: string): Promise<SitefConfig | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'delete',
      url: `payments/sitef/configs/${id}`,
    });
    return parseConfig(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const parseSitefConfigs = (data: any): SitefConfig[] => {
  return data.map((item: any): SitefConfig => parseConfig(item));
};

const parseConfig = (data: any): SitefConfig => {
  return {
    id: data.id,
    description: data.description,
    merchantId: data.merchant_id,
    merchantKey: data.merchant_key,
  };
};
